import { decodeJwtPayload } from "./jwt";
import {
  PlatformRoleValues,
  platformRoleSchema,
  type PlatformRole,
} from "./zod/common";

interface DecodedUserInfo {
  email: string | null;
  id: number | null;
  publicId: string | null;
  gymName: string | null;
  gymPublicId: string | null;
  role: PlatformRole | null;
  theme: string | null;
  language: string | null;
}

const EMPTY_USER_INFO: DecodedUserInfo = {
  email: null,
  id: null,
  publicId: null,
  gymName: null,
  gymPublicId: null,
  role: null,
  theme: null,
  language: null,
};

export function decodeUserInfo(
  token: string | null | undefined,
): DecodedUserInfo {
  const payload = decodeJwtPayload<Record<string, unknown>>(token);
  if (!payload) return EMPTY_USER_INFO;
  // Sale del schema y no de una lista escrita a mano: un rol nuevo que se agregue
  // al enum y no aca se convertiria en `role: null` en silencio, y el usuario
  // entraria con un token valido para caer de vuelta en el login sin ningun error.
  const parsedRole = platformRoleSchema.safeParse(payload.role);
  const role: PlatformRole | null = parsedRole.success ? parsedRole.data : null;
  return {
    email: typeof payload.email === "string" ? payload.email : null,
    id: typeof payload.id === "number" ? payload.id : null,
    publicId: typeof payload.publicId === "string" ? payload.publicId : null,
    gymName: typeof payload.gymName === "string" ? payload.gymName : null,
    gymPublicId:
      typeof payload.gymPublicId === "string" ? payload.gymPublicId : null,
    role,
    theme: typeof payload.theme === "string" ? payload.theme : null,
    language: typeof payload.language === "string" ? payload.language : null,
  };
}

export function isManager(role: PlatformRole | null): boolean {
  return role === PlatformRoleValues.MANAGER;
}

export function isSuperAdmin(role: PlatformRole | null): boolean {
  return role === PlatformRoleValues.SUPERADMIN;
}

export function isStaff(role: PlatformRole | null): boolean {
  return role === PlatformRoleValues.STAFF;
}

export function isManagerOrSuperAdmin(role: PlatformRole | null): boolean {
  return isManager(role) || isSuperAdmin(role);
}
